import { JwtResponse, Login } from "@/types";
import { User } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service";

function modelMapper(inputUser: any): User {
    const name = inputUser.name || "";
    const lastname = inputUser.lastname || "";
    return {
        id: inputUser.id,
        name,
        lastname,
        username: inputUser.username,
        // Do not map the password
        password: '',
        email: inputUser.email,
        telephone: inputUser.telephone,
        avatar: inputUser.avatar,
        roles: inputUser.roles,
        mobile: inputUser.mobile,
        fonction: inputUser.fonction,
        technical: inputUser.technical,
        fullName: `${name} ${lastname}`.trim()
    };
}

export function modelMapperArray(inputArray: any[]): User[] {
    return inputArray.map(modelMapper);
}

export async function getAllUsers(): Promise<User[]> {
    const users = await getData<User[]>("/users");
    return modelMapperArray(users ?? []);
}

export async function getAllTechnicians(): Promise<User[]> {
    const users = await getData<User[]>("/users?technical=true");
    return modelMapperArray(users ?? []);
}

export async function getUserById(id: string): Promise<User> {
    const user = await getData<User>(`/users/${id}`);
    return modelMapper(user);
}


export function postUser(user: User): Promise<any> {
    return postData("/users", user)
}

export function postSignin(login: Login): Promise<JwtResponse> {
    return postData("/auth/login", login)
}

export function putUser(id: string, user: User): Promise<any> {
    return putData("/users/" + id, user)
}

export function deleteUser(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("/users/" + idsStr)
}

export async function searchForUsers(searchQuery: string): Promise<User[]> {
    const users = await getData<User[]>(`/users?${searchQuery}`);
    return modelMapperArray(users ?? []);
}
